import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../../layout/Header";
import Leftpanel from "../../layout/Leftpanel";

const Esprovider = () => {
  const { t } = useTranslation();
  //const totalProvidersCount = 103;

  return (
    <div className="container-fluid">
      <div className="dbMain esprovide">
        <Leftpanel breadcm={t("eis_company")} />
        <div className="dbRight">
          <Header link="/dashboard" title={t("eis_company")} description="" />
          <div className="commonBase mb-4">
            <div className="dbtableTop">
              <div className="dbSearch">
                <h6>{t("eis_connections")}</h6>
              </div>
              <div className="dbtableSrchbg">
                <button
                  className="commonButton"
                  data-bs-toggle="modal"
                  data-bs-target="#esprovideModal"
                >
                  <i className="fa-solid fa-plus"></i>{" "}
                  {t("add") + " " + t("eis_connection")}
                </button>
              </div>
            </div>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("eis_company_name")}</th>
                    <th>{t("identification_number")}</th>
                    <th>{t("status")}</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Sample data rows */}
                  {/* {[...Array(3)].map((_, index) => (
                    <tr key={index}>
                      <td data-label={t("ies_provider_name")}>UNIMAZE</td>
                      <td data-label={t("client_id")}>UNI2351</td>
                      <td data-label={t("status")}>
                        <span className="dbu">{t("active")}</span>
                      </td>
                      <td data-label={t("action")}>
                        <Link to="">
                          <i className="fa-solid fa-trash-can"></i>
                        </Link>
                      </td>
                    </tr>
                  ))} */}
                </tbody>
              </table>
            </div>
          </div>

          {/* Modal */}
          <div
            className="modal fade"
            id="esprovideModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {t("add_es_provider")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3 row">
                    <label
                      htmlFor="staticEmail"
                      className="col-sm-4 col-form-label"
                    >
                      {t("select_es_provider")}
                    </label>
                    <div className="col-sm-8">
                      <select className="form-control">
                        <option value="">{t("select_es_provider")}</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">
                      {t("enter_client_id")}
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="commonButton"
                      data-bs-dismiss="modal"
                    >
                      {t("add")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Esprovider;
